module.exports = __webpack_public_path__ + "media/images/ucl_ctc-e25ae7d32d0f91c5234bd048cdf4ed93.jpg";